import moment from "moment/moment";
import { fieldMapping } from "utils/constant";
import { getUllageTooltip, getUllageValue } from "utils/ullage";

export async function filtereRowData(info, iconsList, badgesList) {
    let updatedInfo = await Promise.all(info.map(async (row) => {
        let entityName;
        if (row.attributes?.entity_address_item?.entity_name) {
            entityName = row.attributes.entity_address_item.entity_name;
        } else if (row.attributes?.entity_address_item?.first_name) {
            entityName = `${row.attributes.entity_address_item.first_name} ${row.attributes.entity_address_item.last_name}`;
        }

        let alert = null;

        if (row?.attributes?.alerts && row?.attributes?.alerts?.length) {
            const alert_s = row?.attributes?.alerts.length > 0 ? row?.attributes?.alerts[row?.attributes?.alerts?.length - 1] : null
            let icon = iconsList.find((e) => e.icon_id === alert_s?.icon_id)
            let badge = badgesList.find((e) => e.badge_id === alert_s?.badge_id)
            // alert = { ...row?.attributes?.alerts, icon, badge: badge }
            alert = { ...alert_s, icon, badge: badge }
        }

        // Check device_type_id from device_data
        if (row.attributes?.device_data?.device_type_id === 8) {
            return processDeviceType8(row, alert, entityName)
        }
        if (row.attributes?.device_data?.device_type_id === 9) {
            return processDeviceType9(row, alert, entityName)
        }
        if (row.attributes?.device_data?.device_type_id === 10) {
            return processDeviceType10(row, alert, entityName)
        }

        return processDeviceType4(row, alert, entityName)
    }));

    return updatedInfo.filter(Boolean);
}

export function processDeviceType10(row, alert, entityName) {
    const { attributes } = row;
    const deviceValue = attributes?.device_value ?? {};
    const deviceData = attributes?.device_data ?? {};
    const geofence = attributes?.geofences ?? attributes?.geofence ?? null;

    const dateString = moment(deviceValue?.last_updated).isValid()
        ? moment(deviceValue.last_updated)
        : moment();

    return {
        id: row.id,
        convert_id: String(row.id),
        alert: alert,
        name: deviceData?.name ?? '',
        entity: entityName,
        entity_address_name: attributes?.entity_address_item?.entity_address_name ?? '',
        identifier: attributes?.external_device_id || deviceData?.external_device_id,
        item: attributes?.entity_address_item?.item_name,
        address: attributes?.entity_address_item?.street_address1,
        city: attributes?.entity_address_item?.city,
        state: attributes?.entity_address_item?.state,
        country: attributes?.entity_address_item?.country,
        postal_code: attributes?.entity_address_item?.postal_code,
        lat: deviceValue?.position_latitude ?? attributes?.entity_address_item?.latitude ?? "Not Available",
        long: deviceValue?.position_longitude ?? attributes?.entity_address_item?.longitude ?? "Not Available",
        percent_level: deviceValue?.level_percent ?? null,
        volume_gallons: deviceValue?.volume_gallons ?? null,
        gallons_remaining: deviceValue?.gallons_remaining ?? null,
        capacity_gallons: deviceValue?.capacity_gallons ?? null,
        psi: deviceValue?.pressure_psi ?? null,
        pressure_mode: deviceValue?.pressure_mode ?? null,
        moment_status: deviceValue?.moment_status ?? null,
        speed: deviceValue?.convert_position_speed ?? null,
        vehicle_connected: deviceValue?.vehicle?.connected ?? null,
        active_fault_count: deviceValue?.vehicle?.active_fault_count ?? null,
        location: geofence?.name ?? deviceValue?.reverse_geocoded_address?.formatted_address ?? null,
        geofence_name: geofence?.name ?? null,
        geofence_color: geofence?.color ?? null,
        last_updated: dateString.fromNow(),
        device_type: 10,
        job_state: row?.state ? row.state.to_state : ''
    };
}

function processDeviceType4(row, alert, entityName) {

    const fieldMapping = {
        46: "latitude",
        47: "longitude",
    };

    const { attributes, device_analytics, device_id } = row;

    let dateRef = attributes?.device_value?.tx_reported ?? attributes?.device_value?.last_updated;
    dateRef = typeof dateRef === 'number' ? new Date(dateRef) : dateRef;
    const dateString = moment(dateRef).isValid() ? moment(dateRef) : moment(new Date());
    const deviceSetupFields = row?.itemAttributeValues?.reduce((acc, item) => {
        const fieldName = fieldMapping[item.attribute_id];
        if (fieldName) {
            acc[fieldName] = item.value;
        }
        return acc;
    }, {});

    return {
        id: row.id,
        convert_id: String(row.id),
        alert: alert,
        percent_level: attributes?.device_value?.device_data?.percent_level ?? device_analytics?.current_percent_level,
        name: row.attributes?.device_data?.name ?? '',
        entity_address_name: attributes?.entity_address_item?.entity_address_name ?? '',
        entity: entityName,
        identifier: attributes?.device_data?.external_device_id,
        item: attributes?.entity_address_item?.item_name,
        createdAt: attributes?.createdAt,
        updatedAt: attributes?.updatedAt,
        address: attributes?.entity_address_item?.street_address1,
        city: attributes?.entity_address_item?.city,
        state: attributes?.entity_address_item?.state,
        country: attributes?.entity_address_item?.country,
        postal_code: attributes?.entity_address_item?.postal_code,
        lat: deviceSetupFields?.latitude || attributes?.entity_address_item?.latitude || "Not Available",
        long: deviceSetupFields?.longitude || attributes?.entity_address_item?.longitude || "Not Available",
        inch_level: Math.ceil(attributes?.device_value?.device_data?.inch_level),
        volume_level: Math.ceil(attributes?.device_value?.device_data?.volume_level),
        ullage_volume: getUllageValue(attributes?.device_value?.device_data, 'ullage_volume'),
        ullage_tooltip: getUllageTooltip(attributes?.device_value?.device_data),
        battery_status: attributes?.device_value?.device_data?.battery_status,
        battery_voltage: attributes?.device_value?.device_data?.battery_voltage,
        wifi_signal: attributes?.device_value?.wifi_signal,
        last_updated: attributes?.device_value?.last_updated_on ?? dateString.fromNow(),
        last24h_percent: device_analytics?.last_24_hours?.percent_change || 0,
        last24h_level: device_analytics?.last_24_hours?.inch_change || 0,
        last24h_volume: device_analytics?.last_24_hours?.volume_change || 0,
        ai_trend: attributes?.analysis_data?.Trend,
        ai_status: attributes?.analysis_data?.Status,
        has_linked_device: attributes?.device_value?.linked_devices?.length > 0,
        linked_devices: attributes?.device_value?.linked_devices,
        device_type: 4
    };
}

function processDeviceType8(row, alert, entityName) {
    const { attributes } = row;
    const rawTimestamp = attributes?.device_value?.timestamp;
    const timestamp = typeof rawTimestamp === 'number'
        ? rawTimestamp * 1000
        : (typeof rawTimestamp === 'string' && rawTimestamp.length === 10)
            ? Number(rawTimestamp) * 1000
            : rawTimestamp;

    const shouldShowAddress = attributes?.device_value?.reverse_geocoded_address?.formatted_address || null;
    return {
        id: row.id,
        convert_id: String(row.id),
        alert: alert,
        name: attributes?.device_data?.name ?? '',
        entity: entityName,
        entity_address_name: attributes?.entity_address_item?.entity_address_name ?? '',
        identifier: attributes?.device_value?.ident,
        moment_status: attributes?.device_value?.moment_status,
        moment_status_duration: attributes?.device_value?.moment_status_duration,
        speed: attributes?.device_value?.convert_position_speed ? `${attributes.device_value.convert_position_speed} m/h` : '',
        battery_level: attributes?.device_value?.battery_level,
        external_powersource_status: attributes?.device_value?.external_powersource_status ? 'True' : 'False',
        engine_ignition_status: attributes?.device_value?.engine_ignition_status ? 'True' : 'False',
        fuel_level: attributes?.device_value?.can_fuel_level ? `${attributes.device_value.can_fuel_level} %` : '',
        rpm: attributes?.device_value?.can_engine_rpm,
        location: attributes?.geofences?.name ?? '',
        should_show_address: shouldShowAddress,
        color: attributes?.geofences?.color ?? '#000',
        item: attributes?.entity_address_item?.item_name,
        createdAt: attributes?.createdAt,
        updatedAt: attributes?.updatedAt,
        address: attributes?.entity_address_item?.street_address1,
        city: attributes?.entity_address_item?.city,
        state: attributes?.entity_address_item?.state,
        country: attributes?.entity_address_item?.country,
        postal_code: attributes?.entity_address_item?.postal_code,
        lat: attributes?.device_value?.position_latitude ||
            attributes?.entity_address_item?.latitude ||
            "Not Available",
        long: attributes?.device_value?.position_longitude ||
            attributes?.entity_address_item?.longitude ||
            "Not Available",
        last_updated: timestamp,
        has_linked_device: attributes?.children?.length > 0 ? true : attributes?.parents?.length > 0,
        linked_devices: attributes?.children?.length > 0 ? attributes?.children : attributes?.parents,
        device_type: 8
    };
}

function processDeviceType9(row, alert, entityName) {
    const fieldMapping = {
        46: "latitude",
        47: "longitude",
    };

    const { attributes, device_analytics } = row;

    const dateString = moment(attributes?.device_value?.last_updated).isValid()
        ? moment(attributes?.device_value?.last_updated)
        : moment(attributes?.device_value?.last_updated, "MMM Do, h:mm A");

    const deviceSetupFields = row?.itemAttributeValues?.reduce((acc, item) => {
        const fieldName = fieldMapping[item.attribute_id];
        if (fieldName) {
            acc[fieldName] = item.value;
        }
        return acc;
    }, {});

    if (!attributes?.device_value?.channels) {
        return null;
    }

    const channels = Object.keys(attributes.device_value.channels);
    // const percent = channels.map(e => attributes.device_value.channels[e].percent_level).join(', ');
    const channels_data = attributes.device_value.channels
    const percent = channels_data?.[9]?.current_value ?? 0;
    const psi = channels_data?.[10]?.current_value ?? 0;
    const fluid_height = channels.map(e => channels_data[e].actual_fluid_height).join(', ');
    const calibrated_level = channels.map(e => channels_data[e].calibrated_level).join(', ');
    const usable_height = channels.map(e => channels_data[e].usable_height).join(', ');
    // const volume_level = channels.map(e => channels_data[e].volume_level).join(', ');
    const volume_level = channels_data?.[9]?.volume_level ?? 0;
    const raw_level = channels.map(e => channels_data[e].raw_level).join(', ');

    return {
        id: row.id,
        convert_id: String(row.id),
        alert: alert,
        percent_level: Number(percent),
        psi: psi,
        name: row.attributes?.device_data?.name ?? '',
        entity_address_name: attributes?.entity_address_item?.entity_address_name ?? '',
        entity: entityName,
        identifier: attributes?.device_data?.external_device_id,
        item: attributes?.entity_address_item?.item_name,
        createdAt: attributes?.createdAt,
        updatedAt: attributes?.updatedAt,
        address: attributes?.entity_address_item?.street_address1,
        city: attributes?.entity_address_item?.city,
        state: attributes?.entity_address_item?.state,
        country: attributes?.entity_address_item?.country,
        postal_code: attributes?.entity_address_item?.postal_code,
        lat: deviceSetupFields?.latitude || attributes?.entity_address_item?.latitude || "Not Available",
        long: deviceSetupFields?.longitude || attributes?.entity_address_item?.longitude || "Not Available",
        fluid_height,
        calibrated_level,
        usable_height,
        volume_level,
        ullage_volume: getUllageValue(channels_data?.[9], 'ullage_volume'),
        ullage_tooltip: getUllageTooltip(channels_data?.[9]),
        raw_level,
        last_updated: dateString.fromNow(),
        has_linked_device: attributes?.children?.length > 0,
        linked_devices: attributes?.children,
        device_type: 9,
        job_state: row?.state ? row.state.to_state : ''
    };
}

function getDeviceLatLng(attributes) {
    const { device_value, entity_address_item, itemAttributeValues, device_data, children } = attributes;
    let lat = parseFloat(device_value?.position_latitude || entity_address_item?.latitude);
    let lng = parseFloat(device_value?.position_longitude || entity_address_item?.longitude);

    if ([4, 9].includes(device_data?.device_type_id)) {
        const deviceSetupFields = itemAttributeValues?.reduce((acc, item) => {
            const fieldName = fieldMapping[item.attribute_id];
            if (fieldName) acc[fieldName] = item.value;
            return acc;
        }, {});
        lat = parseFloat(deviceSetupFields?.latitude || entity_address_item?.latitude);
        lng = parseFloat(deviceSetupFields?.longitude || entity_address_item?.longitude);
    }

    if (children.length > 0 && [4, 9].includes(device_data?.device_type_id)) {
        const { position_latitude, position_longitude } = children[0].device_value
        lat = position_latitude
        lng = position_longitude
    }

    if (!lat || !lng) return null;
    return { lat, lng };
}

function getDeviceText(attributes) {
    const { device_value, entity_address_item, device_data, device_analytics, children } = attributes;
    const device_type_id = device_data?.device_type_id;

    const mapId = entity_address_item?.map_identifier || '';

    if (device_type_id === 4) {
        const level = device_value?.device_data?.percent_level ?? device_analytics?.current_percent_level ?? 0;
        return mapId ? `${mapId} ${level}%` : `${level}%`;
    }
    if (device_type_id === 9 && children.length > 0) {
        const current_value = device_value?.channels?.[9]?.current_value
        const percent = current_value ?? Object.values(device_value?.channels || {}).reduce((sum, ch) => sum + (ch.percent_level ?? 0), 0);
        let mapIde = children[0]?.entity_address_item?.map_identifier
        return mapIde ? `${mapIde} ${percent}%` : `${percent}%`;
    }
    if (device_type_id === 9) {
        const percent = Object.values(device_value?.channels || {}).reduce((sum, ch) => sum + (ch.percent_level ?? 0), 0);
        return mapId ? `${mapId} ${percent}%` : `${percent}%`;
    }
    if (device_type_id === 10) {
        const percent = device_value?.level_percent ?? 0;
        return mapId ? `${mapId} ${percent}%` : `${percent}%`;
    }
    return mapId || `#${attributes.device_id}`;
}

export function processMapDeviceForAll(data = [], badgeList) {
    return data
        .map(e => {
            const latLng = getDeviceLatLng(e.attributes);
            if (!latLng) return null;

            const { lat, lng } = latLng;
            const { device_value, entity_address_item, alerts, device_data, device_id } = e?.attributes;
            const alert = alerts?.length ? alerts[alerts.length - 1] : null
            let color = 'green'
            if (alert) {
                let badge = badgeList.find((e) => e.badge_id === alert?.badge_id)
                if (badge) {
                    color = badge?.font_color_hex ?? 'green'
                }
            }
            return {
                lat,
                lng,
                iconClassName: entity_address_item?.class_name,
                color: color,
                animate: device_value?.moment_status === 'Moving',
                text: getDeviceText(e.attributes),
                title: `${device_data?.name ?? ''} #${device_id}`,
                attributes: e.attributes,
                id: e.id,
                heading: device_value?.position_direction,
                ignore_heading: entity_address_item?.ignore_heading,
                // has_linked_device: device_value?.linked_devices?.length > 0,
                // linked_devices: device_value?.linked_devices
                has_linked_device: e?.attributes?.children?.length > 0 ? true : e?.attributes?.parents?.length > 0,
                linked_devices: e?.attributes?.children?.length > 0 ? e?.attributes?.children : e?.attributes?.parents,
            };
        })
        .filter(Boolean);
}

export function socketProcessDeviceType9(data, linked_devices) {
    const dateString = moment(data?.last_updated).isValid()
        ? moment(data?.last_updated)
        : moment(data?.last_updated, "MMM Do, h:mm A");

    if (!data?.channels) {
        return null;
    }

    const channels = Object.keys(data.channels);
    // const percent = channels.map(e => data.channels[e].percent_level).join(', ');
    const percent = data.channels?.[9]?.current_value ?? 0;
    const psi = data.channels?.[10]?.current_value ?? 0;
    const fluid_height = channels.map(e => data.channels[e].actual_fluid_height).join(', ');
    const calibrated_level = channels.map(e => data.channels[e].calibrated_level).join(', ');
    const usable_height = channels.map(e => data.channels[e].usable_height).join(', ');
    // const volume_level = channels.map(e => data.channels[e].volume_level).join(', ');
    const volume_level = data.channels?.[9]?.volume_level ?? 0;
    const raw_level = channels.map(e => data.channels[e].raw_level).join(', ');
    return {
        percent_level: percent,
        psi,
        fluid_height,
        calibrated_level,
        usable_height,
        volume_level,
        ullage_volume: getUllageValue(data.channels?.[9], 'ullage_volume'),
        ullage_tooltip: getUllageTooltip(data.channels?.[9]),
        raw_level,
        last_updated: dateString.fromNow(),
        has_linked_device: linked_devices?.children?.length > 0 ? true : linked_devices?.parents?.length > 0,
        linked_devices: linked_devices?.children?.length > 0 ? linked_devices?.children : linked_devices?.parents,
        device_type: 9
    };
}
